var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonAddBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-32p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_21146",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.330078,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_21146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_add",
    d: "M24.219 18.9111V14.6889H19.9967V12.4667H24.219V8.24443H26.4412V12.4667H30.6634V14.6889H26.4412V18.9111H24.219ZM11.9967 16.2222C10.5301 16.2222 9.31156 15.737 8.34118 14.7667C7.37082 13.7963 6.88565 12.5778 6.88565 11.1111C6.88565 9.64443 7.37082 8.42592 8.34118 7.45557C9.31156 6.48519 10.5301 6 11.9967 6C13.4634 6 14.6819 6.48519 15.6523 7.45557C16.6227 8.42592 17.1078 9.64443 17.1078 11.1111C17.1078 12.5778 16.6227 13.7963 15.6523 14.7667C14.6819 15.737 13.4634 16.2222 11.9967 16.2222ZM1.33008 26.9111V23.5778C1.33008 22.8074 1.52452 22.1056 1.91341 21.4722C2.3023 20.8389 2.8486 20.363 3.55231 20.0444C5.12269 19.3259 6.57705 18.8093 7.91538 18.4944C9.25373 18.1796 10.613 18.0222 11.9931 18.0222C13.3733 18.0222 14.7301 18.1796 16.0634 18.4944C17.3967 18.8093 18.8486 19.3259 20.419 20.0444C21.1227 20.3778 21.6727 20.8574 22.069 21.4833C22.4653 22.1093 22.6634 22.8074 22.6634 23.5778V26.9111H1.33008ZM3.55228 24.6889H20.4412V23.5778C20.4412 23.2593 20.3542 22.9593 20.1801 22.6778C20.006 22.3963 19.7745 22.1852 19.4856 22.0444C18.0338 21.3555 16.7412 20.8833 15.6078 20.6278C14.4745 20.3722 13.2708 20.2444 11.9967 20.2444C10.7227 20.2444 9.51527 20.3722 8.37451 20.6278C7.23378 20.8833 5.93749 21.3555 4.48565 22.0444C4.19673 22.1852 3.96894 22.3963 3.80228 22.6778C3.63561 22.9593 3.55228 23.2593 3.55228 23.5778V24.6889ZM11.9967 14C12.819 14 13.506 13.7241 14.0578 13.1722C14.6097 12.6204 14.8856 11.9333 14.8856 11.1111C14.8856 10.2889 14.6097 9.60184 14.0578 9.05C13.506 8.49813 12.819 8.2222 11.9967 8.2222C11.1745 8.2222 10.4875 8.49813 9.93565 9.05C9.38378 9.60184 9.10785 10.2889 9.10785 11.1111C9.10785 11.9333 9.38378 12.6204 9.93565 13.1722C10.4875 13.7241 11.1745 14 11.9967 14Z",
    fill: "#21438B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAddBlue);
export default __webpack_public_path__ + "static/media/person_add_blue.bc2350e64254f6442e4daf4047aa0def.svg";
export { ForwardRef as ReactComponent };